export const TRANSLATIONS_FR = {
  academie: "education",
  usage: "guide",
  marche: "marchés",
  planification: "planification",
  rapport: "Rapports",
};
